import React, { useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "./Auth.css";

const Login = ({ setUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [resetMessage, setResetMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim() || !password) {
      setError("Please enter your email and password.");
      return;
    }
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      await userCredential.user.reload();
      if (!userCredential.user.emailVerified) {
        toast.info("Please verify your email to continue. Check your inbox for the link.");
        navigate("/verify-email", { replace: true });
        return;
      }
      setUser(userCredential.user);
      localStorage.setItem("user", JSON.stringify(userCredential.user));
      navigate("/app");
    } catch (err) {
      const code = err?.code;
      const message =
        code === "auth/invalid-credential" ||
        code === "auth/wrong-password" ||
        code === "auth/user-not-found"
          ? "Login failed — check your email and password."
          : code === "auth/too-many-requests"
          ? "Too many attempts. Try again later."
          : "Login failed. Please try again.";
      setError(message);
      console.error(err);
    }
  };

  const handlePasswordReset = async () => {
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setResetMessage("Please enter a valid email address.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMessage("Password reset email sent! Follow the link in your inbox.");
    } catch (err) {
      setResetMessage(`Failed to send reset email: ${err.message}`);
      console.error(err);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <Link to="/" className="auth-back">
        ← Back to Home
        </Link>
        <h1 className="auth-title">Login to Customs Pro AI</h1>
        <p className="auth-subtitle">Welcome back — sign in to continue</p>

        <form onSubmit={handleLogin} className="auth-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="auth-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="auth-input"
          />
          <button type="submit" className="auth-btn">
            Login
          </button>
          {error && <p className="auth-error">{error}</p>}
        </form>

        <p className="auth-secondary">
          <button type="button" onClick={handlePasswordReset} className="text-btn">
            Forgot Password?
          </button>
        </p>

        {resetMessage && <p className="auth-message">{resetMessage}</p>}

        <p className="auth-footer">
          Need an account? <Link to="/register">Register</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;